export const CONFIG_FORM_NEW_USER = "config_newUser";